module.exports = __webpack_public_path__ + "static/media/clouds-2.5c690e75.svg";